module.exports = __webpack_public_path__ + "static/img/22.706cda0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/22.jpg
// module id = 29A3
// module chunks = 0